<template>
  <div>
    <BListFilter
      v-model="form"
      label="Поиск по названию и описанию"
      :skeleton="skeleton"
      dense
      @change="onChangeDebounced"
    />

    <v-row dense>
      <v-col :cols="!skeleton && 'auto'">
        <BAutocompleteCommon
          v-model="form.session_code"
          label="Сессия"
          :options="sessions"
          :skeleton="skeleton"
          :return-object="false"
          item-text="name"
          item-value="digit_code"
          $type="select"
          @change="onChangeDebounced"
        />
      </v-col>

      <v-col :cols="!skeleton && 'auto'">
        <BAutocompleteCommon
          v-model="form.subject_code"
          label="Предмет"
          :options="subjects"
          :skeleton="skeleton"
          :return-object="false"
          item-text="name"
          item-value="digit_code"
          $type="select"
          @change="onChangeDebounced"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BListFilter, { createDefaultData } from '@/components/forms/BListFilter.vue'
import BAutocompleteCommon from '@/components/forms/BAutocompleteCommon.vue'

import {
  marksMapper as StoreMapper,
} from '../store'


const createDefaultDataFilters = () => ({
  ...createDefaultData(),
  is_archived: null,
})

const ARCHIVED_OPTIONS = [
  { label: 'В архиве', value: true },
  { label: 'Не в архиве', value: false },
]

export default {
  name: 'PublicationsFilter',
  components: {
    BListFilter,
    BAutocompleteCommon,
  },
  extends: BListFilter,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      default: createDefaultDataFilters,
    },
  },
  data: () => ({
    archivedOptions: ARCHIVED_OPTIONS,
  }),
  computed: {
    ...StoreMapper.mapState(['sessions', 'subjects']),
  },
}
</script>
